import React from 'react'
import { Card, Collapse } from 'antd'
import ViewLog from '@pages/Logs/Log/ViewLog'
import moment from 'moment'

const { Panel } = Collapse

function UserStoryLog(props) {
    const getHeader = log =>
        `${log._source.creator}: ${log._source.subType}  - ${moment(log._source.date).format('DD/MM/YY HH:mm:ss')}`
    const getStyle = log => {
        const res = {}
        log._source.type === 'ERROR' ? (res.backgroundColor = 'red') : (res.backgroundColor = 'gray')
        log._id === props.id ? (res.border = '5px solid black') : (res.border = 'none')
        return res
    }

    return (
        <Card title="User story">
            {props.userStory.map((log, index) => (
                <Collapse style={getStyle(log)} key={index}>
                    <Panel header={getHeader(log)} key={index}>
                        <ViewLog log={log._source} />
                    </Panel>
                </Collapse>
            ))}
        </Card>
    )
}

export default UserStoryLog
